import { useNavigate } from "react-router-dom";
import { listCores } from "../registry/toolRegistry";
import { titleCase } from "../lib/format";
import { cx } from "../ui";

// §11 obere Tool-Tabs = `registry.list({category})` (§4) — die Tools der aktiven
// Kategorie. Tab-Wechsel routet auf das jeweilige Tool. Reihenfolge = Registry-Order.

export function ToolTabs({ category, activeToolId }: { category: string; activeToolId: string }) {
  const navigate = useNavigate();
  const tools = listCores(category);

  return (
    <div className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto px-2">
      {tools.map((t) => {
        const active = t.id === activeToolId;
        return (
          <button
            key={t.id}
            type="button"
            aria-current={active ? "page" : undefined}
            onClick={() => navigate(`/generate/${category}/${t.id}`)}
            className={cx(
              "relative whitespace-nowrap rounded-t-lg px-3.5 py-3 text-sm transition-colors",
              active
                ? "bg-surface-2 font-semibold text-accent"
                : "font-medium text-muted hover:bg-surface-2/40 hover:text-text",
            )}
          >
            {titleCase(t.id)}
            {active && <span className="absolute inset-x-0 -bottom-px h-0.5 accent-gradient" />}
          </button>
        );
      })}
    </div>
  );
}
